<div class="site-text">
    <p class="text">
        eDirectory fait partie des activités de swissDIGIN et est géré par PostFinance SA. L’exploitation technique est assurée sur mandat de PostFinance SA par l’entreprise xeFex SA.
    </p>
    <p class="title">
        swissDIGIN
    </p>
    <p class="text">
        L’initiative swissDIGIN (swiss Digital Invoice) vise à favoriser l’échange électronique de factures entre les entreprises et les organisations (en un mot: l’e-facturation) dans toute la Suisse. À cette fin, swissDIGIN met son savoir-faire à disposition des entreprises, en toute neutralité.
        <br>
        <a href="https://www.swissdigin.ch" target="_blank">www.swissdigin.ch</a>
    </p>
    <p class="title">
        PostFinance AG
    </p>
    <p class="text">
        En tant que leadeuse du marché suisse dans le secteur de l’e-facture, PostFinance numérise la facturation et la réception de factures de ses clients depuis plus de 20 ans.
        PostFinance est à la fois prestataire de services d’e-facturation, partenaire réseau de eBill et banque affiliée à eBill. Grâce à la solution de PostFinance, les entreprises et les organisations peuvent à la fois échanger des e-factures avec leurs partenaires commerciaux et envoyer et recevoir des eBill afin de dynamiser leurs processus. Les clientes et clients commerciaux profitent ainsi d’un conseil global et ont à leur disposition une interlocutrice qui couvre tous leurs besoins autour de l’e-facturation.
        <br>
        <a href="https://www.postfinance.ch/billing-solutions" target="_blank">www.postfinance.ch/billing-solutions</a>
    </p>
    <p class="title">
        xeFex SA
    </p>
    <p class="text">
        xeFex SA réalise des prestations informatiques dans les domaines de la programmation, du conseil et de la direction de projets.
        <br>
        <a href="https://www.xefex.ch" target="_blank">www.xefex.ch</a>
    </p>
    <p class="title">
        Prestataire de services d’e-facturation
    </p>
    <p class="text">
        Les prestataires de services d’e-facturation suivants inscrivent les émetteurs et récepteurs de factures rattachés à leur réseau et intéressés par une meilleure solution d’e-facturation sur eDirectory.ch.
    </p>
    <a class="logo" href="https://www.postfinance.ch/billing-solutions" target="_blank"><img src="/assets/images/post_finance.png" alt="postfinance logo"></a>
    <a class="logo" href="https://www.abacus.ch" target="_blank"><img src="/assets/images/abacus_full.png" alt="abacus logo"></a>
    <p class="text">
        Si, en tant que prestataire de services d’e-facturation, vous proposez à des entreprises et organisations domiciliées en Suisse des prestations d’e-facturation et que vous souhaitez publier vos clients sur eDirectory, merci de faire part de votre intérêt à PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. Nous vous contacterons le plus rapidement possible.
    </p>
</div>
